import React from 'react';

import Header from '../components/Header/Header';
import Hero from '../components/Hero/Hero';

import Collections from '../components/Collections/Collections';

import Footer from '../components/Footer/Footer';
import ModalSearch from '../components/Modal/ModalSearch';
import ModalMenu from '../components/Modal/ModalMenu';
import Scrollup from '../components/Scrollup/Scrollup';
// import FeaturedProjects from '../components/FeaturedProjects/FeaturedProjects';

const HomePage= ()=>  {
  
        return (
            <div className="main">
                <Header />
                <Hero />
                {/* <FeaturedProjects/> */}
                <Collections />
               
                <Footer />
                <ModalSearch />
                <ModalMenu />
                <Scrollup />
            </div>
        );
  
}

export default HomePage;